import { CareReviewsPage } from "@/components/care-reviews/care-reviews-page";
import { useCareReviewCount } from "@/lib/api/care";
import { useAbility } from "@/lib/casl/ability-context";
import { hasPrivilegedAccessFromAbility } from "@/lib/casl/privileged-access";
import { requirePermission } from "@/lib/casl/route-guards";
import { useCan } from "@/lib/casl/use-can";
import { createFileRoute, Navigate } from "@tanstack/react-router";
import { Loader2 } from "lucide-react";

export const Route = createFileRoute("/_authenticated/care-reviews")({
  component: CareReviewsGate,
  beforeLoad: ({ context }) => {
    requirePermission(context.user, "read", "care");
  },
});

function CareReviewsGate() {
  const ability = useAbility();
  const can = useCan();
  const privileged = hasPrivilegedAccessFromAbility(ability);
  const counts = useCareReviewCount(can("read", "care"));

  if (!privileged && counts.isPending) {
    return (
      <div
        role="status"
        className="flex min-h-screen items-center justify-center bg-surfaces-z3"
      >
        <Loader2 className="size-8 animate-spin text-blue-brand" aria-hidden />
        <span className="sr-only">Loading care reviews</span>
      </div>
    );
  }

  if (!privileged && counts.isError) {
    return (
      <div
        role="alert"
        className="flex min-h-screen flex-col items-center justify-center gap-3 bg-surfaces-z3"
      >
        <p className="font-body text-sm text-states-error">
          Unable to load care reviews.
        </p>
        <button
          type="button"
          onClick={() => void counts.refetch()}
          className="font-body text-sm underline"
        >
          Retry
        </button>
      </div>
    );
  }

  if (!privileged && counts.visible === false) {
    return <Navigate to="/" replace />;
  }

  return <CareReviewsPage />;
}
